import React, { useRef, useState } from 'react';
import Select from 'react-select';
import { FormControlLabelAndPopover } from '../FormControlLabel';
import { ValidationErrorsMessages } from '../FormValidation';

export const DropDownListControl = ({ field, handleChange, handleBlur, formDataEntry, errors } : ControlParameters) : JSX.Element => {
  const options = field.settings.Options.split(/\r?\n/).map(option => {
    const [value, label] = option.split(';');
    return { value, label };
  });
  
  const [selectedValue, setSelectedValue] = useState(options.find(option => option.value.toString() === (formDataEntry?.value?.toString() ?? "")));
  const [input, setInput] = useState('');
  const selectRef = useRef(null);
  
  if(formDataEntry && (formDataEntry?.value?.toString() ?? "") != (selectedValue?.value?.toString() ?? "")) {
    setSelectedValue(options.find(option => option.value.toString() === (formDataEntry?.value?.toString() ?? "")) ?? null);
  }

  const handleDropDownChange = selectedOption => {
    handleChange({
      target: {
        name: field["@column"],
        value: selectedOption?.value ?? null
      }
    });

    setInput('');
  };

  const findClosestOptionForInput = () => {
    if(input == '') {
      return '';
    }

    const foundOptions = options.filter((option) => {
      return option.label?.trim().toLowerCase().includes(input.trim().toLowerCase());
    });

    if(foundOptions?.length > 0) {
      let foundOption = foundOptions.find((option) => {
        return option.label?.trim().toLowerCase() == input.trim().toLowerCase();
      });

      if(!foundOption) {
        foundOption = foundOptions[0];
      }

      return foundOption;
    }

    return selectedValue ?? '';
  }

  const handleOnKeyDown = (event): void => {
    if(event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();

      const option = findClosestOptionForInput();
      handleDropDownChange(option);

      setInput('');
     
      selectRef.current.blur();
    }
  }

  const handleInputChange = (newInputValue, { action }) => {
    if (action === 'input-change') {
      if(newInputValue == '') {
        handleDropDownChange(options[0]);
      }

      setInput(newInputValue);
    }
  };

  const handleOnFocus = (): void => {
    setInput(selectedValue?.label ?? input)
  }

  const handleOnBlur = (event): void => {
    const option = findClosestOptionForInput();
    if(option) {
      handleDropDownChange(option);
    }

    if(selectedValue?.label) {
      setInput('')
    }
    handleBlur(event);
  }

  return (
    <div className={`form-group form__section-input ${field.properties?.fieldcssclass ?? ''}`} key={field["@guid"]}>
      <FormControlLabelAndPopover field={field} loading={formDataEntry.loading} />
      <Select
        id={field["@column"]}
        ref={selectRef}
        className={"form-control searchahead-react-select"}
        classNamePrefix="searchahead-react-select"
        name={field["@column"]}
        onBlur={handleOnBlur}
        onChange={handleDropDownChange}
        inputValue={input}
        onInputChange={handleInputChange}
        onFocus={handleOnFocus}
        onKeyDown={handleOnKeyDown}
        defaultValue={selectedValue}
        value={selectedValue}
        options={options}
        placeholder=""
        required={!field["@allowempty"]}
        noOptionsMessage={() => null}
      />
      <ValidationErrorsMessages keyGuid={field["@guid"]} errors={errors} />
    </div>
  );
};